import { jsx as _jsx } from "react/jsx-runtime";
import { Textarea } from '@heroui/react';
export const TextArea = (props) => {
    return _jsx(Textarea, { ...props });
};
//# sourceMappingURL=TextArea.js.map